import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@devhop/ui";
import type { RoomUsageByRoomItemDTO } from "../api/client";

type RoomUsageReportTableProps = {
  isLoading: boolean;
  data: RoomUsageByRoomItemDTO[];
};

export function RoomUsageReportTable({
  isLoading,
  data,
}: RoomUsageReportTableProps) {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[200px]">ຫ້ອງ</TableHead>
            <TableHead className="w-[160px] text-right">ຊົ່ວໂມງທີ່ໃຊ້</TableHead>
            <TableHead className="w-[140px] text-right">
              ຈຳນວນຄັ້ງ
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell
                colSpan={3}
                className="h-24 text-center text-muted-foreground"
              >
                ກຳລັງໂຫລດ...
              </TableCell>
            </TableRow>
          ) : data.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={3}
                className="h-24 text-center text-muted-foreground"
              >
                ບໍ່ພົບຂໍ້ມູນໃນຊ່ວງວັນທີ່ເລືອກ
              </TableCell>
            </TableRow>
          ) : (
            data.map((row) => (
              <TableRow key={row.roomId}>
                <TableCell className="font-medium">{row.roomName}</TableCell>
                <TableCell className="text-right tabular-nums">
                  {row.hoursUsed.toLocaleString()} ຊົ່ວໂມງ
                </TableCell>
                <TableCell className="text-right tabular-nums">
                  {row.sessionsCount.toLocaleString()}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
